<template>
  <div style="min-width: 25px; max-width: 25px" @click.stop="emit('toggle', item)">
    <ui-icon v-if="isPickedAll" size="16" :color="$colors.green" icon="fas fa-check-square"></ui-icon>
    <ui-icon
      v-else-if="!isPickedAll && isBrandSelected"
      size="16"
      :color="$colors.green"
      icon="fas fa-minus-square"
    ></ui-icon>
    <ui-icon v-else size="16" :color="$colors.gray50" icon="far fa-square"></ui-icon>
  </div>
</template>

<script setup lang="ts">
import { useColors } from '@/composables';
import { useFlowThreePanelCategoryItemAction } from './useFlowThreePanelCategoryItemAction';

const $colors = useColors();

const props = defineProps<{
  selectedBrands: string[];
  brandSelectAllIndex: Record<string, boolean>;
  item: { name: string };
  prefix: string;
  noEvents?: boolean;
}>();

const emit = defineEmits<{
  toggle: [item: typeof props.item];
}>();

const { isPickedAll, isBrandSelected } = useFlowThreePanelCategoryItemAction(props);
</script>
